export { default as parseColor } from './color/parse-color';
export { default as namedColors } from './color/named-colors';
export { default as Color } from './color/color';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-drawing/dist/es/common/color.js
// module id = 1805
// module chunks = 29